import React, { useState, useEffect } from "react";
import { InputBox, SubmitButton, TextAreaBox } from "../../components/Input";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast.jsx";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";


const EditServiceSeo = () => {
  const { id } = useParams();

  const [service, setService] = useState({});
  const [faqs, setFaqs] = useState([]);

  const [seoTitle, setSeoTitle] = useState("");
  const [seoKeywords, setSeoKeywords] = useState("");
  const [seoDesc, setSeoDesc] = useState("");
  const [metaTags, setMetaTags] = useState("");
  const [schemaScriptAddition, setSchemaScriptAddition] = useState("");
  const [faqList, setFaqList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch service + faq details
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("authToken");
        const response = await axios.get(`${API_URL}seoService/edit/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const serviceData = response.data?.service;
        const faqsData = response.data?.faqs || [];

        if (serviceData) {
          setService(serviceData);
          setSeoTitle(serviceData.seo_title || "");
          setSeoKeywords(serviceData.seo_keywords || "");
          setSeoDesc(serviceData.seo_desc || "");
          setMetaTags(serviceData.meta_tags || "");
          setSchemaScriptAddition(serviceData.schema_script_addition || "");
        }

        // Normalize FAQ data
        const transformedFaqs = faqsData.map((faq) => ({
          id: faq.id,
          question: faq.title || "",
          answer: faq.description || "",
        }));
        setFaqList(transformedFaqs);
      } catch (error) {
        console.error("Error fetching SEO service data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const addFaq = () => {
    setFaqList([...faqList, { question: "", answer: "", id: Date.now() }]);
  };

  const deleteFaq = (faqId) => {
    setFaqList(faqList.filter((faq) => faq.id !== faqId));
  };

  const handleFaqChange = (index, field, value) => {
    const updatedFaqList = [...faqList];
    updatedFaqList[index][field] = value;
    setFaqList(updatedFaqList);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const faqids = faqList.map((faq) => faq.id);
    const question = faqList.map((faq) => faq.question);
    const answer = faqList.map((faq) => faq.answer);

    const payload = {
      seo_title: seoTitle,
      seo_desc: seoDesc,
      meta_tags: metaTags,
      schema_script_addition: schemaScriptAddition,
      faqids,
      question,
      answer,
    };

    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await axios.put(`${API_URL}seoService/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        showToast.success("Service SEO updated successfully.", "success");
        navigate("/Seo/Services");
        // Optionally redirect or refresh
      } else {
        showToast.error("Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error updating service SEO:", error);
      showToast.error("Failed to update. Check console for details.", "error");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="page-container page-header-fixed page-sidebar-fixed fade in mt-5">
      <div className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">
                Edit Service Seo - {service?.service_name}
              </span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4 mb-2">
                  <div className="form-group">
                    <InputBox
                      label="Seo Title"
                      fieldname="seo_title"
                      placeholder="Enter Seo Title"
                      value={seoTitle}
                      onChange={(e) => setSeoTitle(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <TextAreaBox
                    label="Seo Description"
                    fieldname="seo_desc"
                    placeholder="Enter Seo Description"
                    value={seoDesc}
                    onChange={(e) => setSeoDesc(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <TextAreaBox
                    label="Meta Tags"
                    fieldname="meta_tags"
                    placeholder="Enter Meta Tags"
                    value={metaTags}
                    onChange={(e) => setMetaTags(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <TextAreaBox
                    label="Schema Script Addition"
                    fieldname="schema_script_addition"
                    placeholder="Enter Schema Script Addition"
                    value={schemaScriptAddition}
                    onChange={(e) => setSchemaScriptAddition(e.target.value)}
                  />
                </div>
              </div>

              {/* FAQ section */}
              <div className="faq_div mt-5">
                <div className="panel-heading border-0 p-0">
                  <span className="panel-title">
                    Frequently Asked Questions
                  </span>
                </div>
                <div className="row clonelist">
                  <table className="table m-b-0 col-12">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center", width: "30%" }}>
                          Title
                        </th>
                        <th style={{ textAlign: "center", width: "30%" }}>
                          Description
                        </th>
                        <th style={{ textAlign: "center", width: "10%" }}>
                          Delete
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {faqList.map((faq, index) => (
                        <tr key={faq.id}>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={faq.question}
                              onChange={(e) =>
                                handleFaqChange(
                                  index,
                                  "question",
                                  e.target.value
                                )
                              }
                              placeholder="FAQ Question"
                            />
                          </td>
                          <td>
                            <textarea
                              className="form-control"
                              value={faq.answer}
                              onChange={(e) =>
                                handleFaqChange(index, "answer", e.target.value)
                              }
                              placeholder="FAQ Answer"
                            />
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-danger btn-gradient delete_row btn-alt pt5 pb5 mn"
                              onClick={() => deleteFaq(faq.id)}
                              title="Delete Record"
                            >
                              X Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3">
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={addFaq}
                          >
                            Add Data
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="form-group">
                <SubmitButton
                  pageBack="/Seo/Services"
                  handleSubmit={handleSubmit}
                  disabled={loading}
                />
                {loading && <div className="mt-2">Saving changes...</div>}
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Scroll top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default EditServiceSeo;
